import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { EarningSchema } from "model/_base/earning";
import { AffiliateSchema, AffiliateReadSchema, AddressSchema, BankingInfoSchema, SocialMediaSchema } from "model/_base/affiliates";
import { PaymentSchema } from "model/_base/earning";

export const DataSchema = EarningSchema.clone()
  .transform(transformSnakeToCamel)
  .shape({
    partner: AffiliateReadSchema.clone()
      .transform(transformSnakeToCamel)
      .concat(Yup.object().transform(transformSnakeToCamel))
      .shape({
        address: AddressSchema.default(undefined),
        bankAccounts: Yup.array().of(BankingInfoSchema).default(undefined),
        socialMedia: Yup.array().of(SocialMediaSchema).default(undefined),
      }),
    paymentEvidences: Yup.array().of(PaymentSchema).default(undefined),
  });

export default class EarningModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = DataSchema.cast(json.data, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
